import React from "react";
import BannerHeader from "../../Component/Header/BannerHeader";
import Footer from "../../Component/Footer/Footer";
import "./whitepaper.css";

const DOCUMENT_ID = "1h0Z0G4_oMYoddP0-X7d39BTa-tSMCwBE_9NTRlTqkrY";
const PREVIEW_URL = `https://docs.google.com/document/d/${DOCUMENT_ID}/preview`;
const DOCUMENT_URL = `https://docs.google.com/document/d/${DOCUMENT_ID}/edit?usp=sharing`;

const Whitepaper = () => (
  <>
    <BannerHeader />
    <main className="whitepaper-page">
      <section className="whitepaper-heading">
        <p>Documentation</p>
        <h1>Simule White Paper</h1>
        <span>Explore the vision, technology, and ecosystem behind Simule.</span>
      </section>

      <section className="whitepaper-viewer" aria-label="Simule white paper document">
        <iframe
          src={PREVIEW_URL}
          title="Simule White Paper"
          loading="eager"
          allowFullScreen
        />
        <p className="whitepaper-fallback">
          If the document does not appear, {" "}
          <a href={DOCUMENT_URL} target="_blank" rel="noopener noreferrer">
            open the white paper in Google Docs
          </a>.
        </p>
      </section>
    </main>
    <Footer />
  </>
);

export default Whitepaper;
